import Vue from 'vue';
const state = {
    msg: '',
    type: '',
    status: ''
};

const mutations = {

};

const actions = {
    mensaje({ state, commit }, status) {
        console.log('notification', status);
        /* Vue.prototype.$message({
             showClose: false,
             center: true,
             message: 'El registro se validó con éxito, folio: ' + data.folioSiar,
             type: 'success'
         });
         */
    },
    ok({ state, commit }, { msg }) {
        Vue.prototype.$notify({
            title: 'Éxito',
            message: msg,
            position: 'top-right',
            offset: 100,
            type: 'success'
        });
    },
    warning({ state, commit }, { msg }) {
        Vue.prototype.$notify({
            title: 'Atención',
            message: msg,
            position: 'top-right',
            offset: 100,
            type: 'warning'
        });
    },
    error({ state, commit }, { msg }) {
        Vue.prototype.$notify({
            title: 'Error',
            message: msg,
            position: 'top-right',
            offset: 100,
            type: 'error'
            //type: 'info'
        });
    },

};

const getters = {

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
